// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KTBef","tabsBox":"styles_tabsBox__pI7QR","createButton":"styles_createButton__2Hkls"};